<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <form>
      <div class="row">
        <div class="col-md-6">
          <div class="group_mdi">
            <input name="first_name" type="password" v-model="data.oldPassword" />
            <label>کلمه عبور فعلی</label>
            <span data-v-378b8112="" class="highlight"></span><span data-v-378b8112="" class="bar"></span>
          </div>
          <div></div>
        </div>

        <div class="col-md-6">
          <div class="group_mdi">
            <input name="first_name" id="first_name" type="password" v-model="data.password"
              @blur="$v.data.password.$touch()" :class="{ invalid: $v.data.password.$error }" />
            <span data-v-378b8112="" class="highlight"></span><span data-v-378b8112="" class="bar"></span>
            <label>کلمه عبور جدید</label>
            <p class="text-danger" v-if="data.password.length < 6 && $v.data.password.$dirty">
              کلمه عبور حداقل شامل 6 کاراکتر باشد
            </p>
            <!-- <p
              class="text-danger"
              v-if="passwordValidation.errors.length && $v.data.password.$dirty"
            >
              کلمه عبور باید شامل حروف کوچک، بزرگ و حداقل یک کاراکتر خاص باشد
            </p> -->
          </div>
          <div></div>
        </div>


        <div class="col-md-6">
          <div class="group_mdi">
            <input name="first_name" type="password" v-model="data.confirmPassword"
              @blur="$v.data.confirmPassword.$touch()" :class="{ invalid: $v.data.confirmPassword.$error }" />
            <span data-v-378b8112="" class="highlight"></span><span data-v-378b8112="" class="bar"></span>
            <label>تکرار کلمه عبور جدید</label>
            <p class="text-danger" v-if="!$v.data.confirmPassword.sameAsPassword">
              تکرار کلمه عبور صحیح نمی باشد
            </p>
          </div>
        </div>
      </div>

      <hr />
      <div class="btn-align">
        <button type="submit" class="btn btn-primary" @click.prevent="changePassword" :disabled="$v.$invalid"
          :class="{ disabledBtn: $v.$invalid }">
          ویرایش اطلاعات
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import store from "../../views/profile/store/index";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: "ChangePassword",
  store: store,
  data() {
    return {
      data: {
        userId: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      rules: [
        { message: "One lowercase letter required.", regex: /[a-z]+/ },
        { message: "One uppercase letter required.", regex: /[A-Z]+/ },
        { message: "special characters minimum.", regex: /[!@#$%^&*()_+]/ },
        // { message: "One number required.", regex: /[0-9]+/ },
      ],
    };
  },
  validations: {
    data: {
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs("password") },
    },
  },

  mounted() {
    this.getUserId();
  },
  computed: {
    passwordValidation() {
      let errors = [];

      for (let condition of this.rules) {
        if (!condition.regex.test(this.data.password)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
  },
  methods: {
    async getUserId() {
      await this.$store.dispatch("getUserId").then(() => {
        this.data.userId = this.$store.getters.GetUserId;
      });
    },
    changePassword() {
      this.$store.dispatch("ChangePassword", this.data).then((res) => {
        if (res != undefined) {
          if (res.status == 200) {
            // alert("تغییر کلمه عبور با موفقیت انجام گردید");
            this.$toast.success("تغییر کلمه عبور با موفقیت انجام گردید", {
              position: "top-center",
              timeout: 4500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1.59,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              icon: true,
              rtl: true,
            });
            const data = {
              isUpdatedPassword: true,
              profileId: this.data.userId,

              password: this.data.password,
            };
            this.$store.dispatch("updateIsUpdatedPassword", data);
          } else {
            // alert("خطا در بروز رسانی کلمه عبور");
            this.$toast.error("خطا در بروز رسانی کلمه عبور", {
              position: "top-center",
              timeout: 4500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1.59,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              icon: true,
              rtl: true,
            });
          }
        } else {
          // alert("خطا در بروز رسانی کلمه عبور");
          this.$toast.error("خطا در بروز رسانی کلمه عبور", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
h4 {
  margin: 30px 0px 40px 0px;
}

.invalid {
  border_bottom: 1px solid red !important;
}

.disabledBtn {
  background-color: #b0c7b9 !important;
}
</style>

